export enum ErrorLogType {
  ErpAgencySync = 'erpAgencySync',
  ErpAgencyCompanySync = 'erpAgencyCompanySync',
  ErpCompanySync = 'erpCompanySync',
}
